import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FruitifyContainer } from "../../../shared-components/Containers";
import GeneralLoading from "../../../shared-components/Loading";
import { useApiClient } from "../../../api";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { withPageTracking } from "../../../services/postHog";

const AnswerAnonymousView = () => {
  const { answerId } = useParams();
  const ApiClient = useApiClient();

  const [answer, setAnswer] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (answerId) {
      fetchAnonymousAnswer();
    }
  }, [answerId]);

  const fetchAnonymousAnswer = async () => {
    setLoading(true);
    try {
      const response = await ApiClient.assignment.getAnonymousAnswer({
        answer: answerId,
      });
      setAnswer(response.anonymousAnswer);
    } catch (error) {
      console.error("Failed to fetch answer", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !answer) {
    return <GeneralLoading />;
  }
  return (
    <FruitifyContainer>
      <Card>
        <CardContent>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant={"h5"}>Example Answer</Typography>
            <Typography variant={"subtitle1"}>
              Mark: {answer.teacherFeedback.mark} / {answer.availableMarks}
            </Typography>
          </Stack>
          <Box sx={{ mt: 2 }}>
            <Typography variant={"body1"}>{answer.answer}</Typography>
          </Box>
        </CardContent>
      </Card>
    </FruitifyContainer>
  );
};

export default withPageTracking(AnswerAnonymousView, {
  feature: "anonymous-answer-view",
});
